import { render, staticRenderFns } from "./onPhoneDes.vue?vue&type=template&id=666ee37f&scoped=true"
import script from "./onPhoneDes.vue?vue&type=script&lang=js"
export * from "./onPhoneDes.vue?vue&type=script&lang=js"
import style0 from "./onPhoneDes.vue?vue&type=style&index=0&id=666ee37f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666ee37f",
  null
  
)

export default component.exports